// extracted by mini-css-extract-plugin
module.exports = {"btn_base":"btn_base--RWelBjWb","toatlText":"toatlText--Wjf_Q8t3"};